/**
* Some elements are controlled components. This means that user
* actions are dispatched as events and subsequent event handling
* is delegated to the using component.
*/

/**
* Here we keep a list of ALL events related to menu elements.
*/
var listItemTopLevelClicked = 'menus/list-item-top-level-clicked';
var listItemSublevelClicked = 'menus/list-item-sublevel-clicked';
var secondaryListItemClicked = 'menus/secondary-list-item-clicked';
var listItemClicked = 'menus/list-item-clicked';
var navItemWithChevronHovered = 'menus/nav-item-with-chevron-hovered';
var navItemWithChevronSmallClicked = 'menus/nav-item-with-chevron-small-clicked';
var navItemWithChevronLargeClicked = 'menus/nav-item-with-chevron-large-clicked';
var dropdownMenuSmallClicked = 'menus/dropdown-menu-small-clicked';
var clickOutsideDropdownMenuSmall = 'menus/click-outside-dropdown-menu-small';
var primaryListItemClicked = 'menus/primary-list-item-clicked';
var navItemWithIconClicked = 'menus/nav-item-with-icon-clicked';
var navItemWithIconHovered = 'menus/nav-item-with-icon-hovered';
var listItemWithButtonClicked = 'menus/list-item-with-button-clicked';
var listItemWithIconHovered = 'menus/list-item-with-icon-hovered';
var listItemWithIconClicked = 'menus/list-item-with-icon-clicked';
/**
* Here we keep a list of ALL events related to navigation elements.
*/

var navItemHovered = 'navigation/nav-item-hovered';
var navItemClicked = 'navigation/nav-item-clicked';
var navCtaClicked = 'navigation/nav-cta-clicked';
var navCtaHovered = 'navigation/nav-cta-hovered';
var drawerOverlayClicked = 'navigation/drawer-overlay-clicked';
var hamburgerToggleClicked = 'navigation/hamburger-toggle-clicked';
var ppoExitButtonClicked = 'navigation/ppo-exit-button';
var modalLinkClicked = 'navigation/modal-link-clicked';
var modalButtonClicked = 'navigation/modal-button-clicked';
var navigationModalClose = 'navigation-modal-close-request';
/**
* Here we keep a list of ALL events related to icon elements.
*/

var modsyLogoClicked = 'icon/modsy-logo-clicked';
var modsyHeartLogoClicked = 'icon/modsy-heart-logo-clicked';
/**
* Here we keep a list of ALL events related to selection control elements.
*/

var unsegmentedControlWithImageOnlyClicked = 'selection-controls/unsegmented-control-with-image-only-clicked';
var unsegmentedControlWithBackgroundColorClicked = 'selection-controls/unsegmented-control-with-background-color-clicked';
var segmentedControlClicked = 'selection-controls/segmented-control-clicked';
export { clickOutsideDropdownMenuSmall, drawerOverlayClicked, dropdownMenuSmallClicked, hamburgerToggleClicked, listItemClicked, listItemSublevelClicked, listItemTopLevelClicked, listItemWithButtonClicked, listItemWithIconClicked, listItemWithIconHovered, modalButtonClicked, modalLinkClicked, modsyHeartLogoClicked, modsyLogoClicked, navCtaClicked, navCtaHovered, navItemClicked, navItemHovered, navItemWithChevronHovered, navItemWithChevronLargeClicked, navItemWithChevronSmallClicked, navItemWithIconClicked, navItemWithIconHovered, navigationModalClose, ppoExitButtonClicked, primaryListItemClicked, secondaryListItemClicked, segmentedControlClicked, unsegmentedControlWithBackgroundColorClicked, unsegmentedControlWithImageOnlyClicked };